module.exports = __webpack_public_path__ + "img/logo-icon.eda3bdaf.svg";